import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TerminologyState } from '../../entities';
import * as fromTerminology from '../reducers/terminology.reducer';

export const selectTerminologyState = createFeatureSelector<TerminologyState>(
  fromTerminology.terminologyFeatureKey
);
